import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../../_metronic/layout";
import { ReportDetailTable } from "./ReportDetailTable";
import { useSelector, useDispatch } from "react-redux";
import {
  resetData,
  selectData,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  selectStatusParam,
  selectReasonParam,
  fetchAll,
  fetchStatusParam,
  fetchReasonParam,
} from "./reportDetailSlice";
import Select from "react-select";
import { useParams } from "react-router-dom";
import { selectUser } from "../../../modules/Auth/_redux/authRedux";
import { checkRoles, formatDatePost, showErrorDialog } from "../../../utility";
import MultiSelectAll from "../../../utility/MultiSelectAll";
import LoadingFetchData from "../../new-return/without-rtv/LoadingFetchData";
import moment from "moment";
import DatePicker from "react-datepicker";
import {
  fetchClient,
  selectDataClient,
} from "../../new-return/with-rtv/withrtvSlice";

export const ReportDetailPage = () => {
  const dispatch = useDispatch();
  const data = useSelector(selectData);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const statusParam = useSelector(selectStatusParam);
  const reasonParam = useSelector(selectReasonParam);
  const dataClient = useSelector(selectDataClient);
  const user = useSelector(selectUser);

  const codeClient = user.clientCode === undefined ? "" : user.clientCode;
  const plants = user.plants.map((e) => {
    return e.plantCode;
  });

  const plantsNameUser = user.plants.map((e) => {
    return e.plantName;
  });

  const defaultPlant = user.plants.map((e) => {
    return e.plantCode.toString();
  });
  const defaultClient = user.clients.map((e) => {
    return e.clientCode.toString();
  });

  // Filter
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [retNumber, setRetNumber] = useState("");
  const [invoiceNo, setInvoiceNo] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [customerCode, setCustomerCode] = useState("");
  const [clientCode, setClientCode] = useState([]);
  const [reason, setReason] = useState("");
  const [status, setStatus] = useState("");
  const [materialName, setMaterialName] = useState("");
  const [materialCode, setMaterialCode] = useState("");
  const [plantCode, setPlantCode] = useState([]);
  const [overlay, setOverlay] = useState(false);

  const [tableData, setTableData] = useState(data);

  console.log(startDate, "startDate");

  const { id } = useParams();

  let dateDefault =
    new Date().getFullYear() +
    "-" +
    (new Date().getMonth() + 1) +
    "-" +
    new Date().getDate();

  const filterStartDate = moment(dateDefault).format("YYYY-MM-DD");

  // useEffect(() => {
  //   setStartDate(filterStartDate);
  //   setEndDate(filterStartDate);
  // }, []);

  const role = user.roles.map((e) => {
    return e.roleName;
  });
  const clientAllowed = ["CLIENT","OPERATION_HO"];

  const clientRole = user.roles.find((role) => role.roleName === "CLIENT");

  useEffect(() => {
    // Add number

    const pageBefore = pageSize * (pageNo - 1);
    if (data !== null) {
      const initData = data.map((item, index) => {
        return {
          ...item,
          no: index + 1 + pageBefore,
        };
      });
      setTableData(initData);
    }
  }, [data, pageSize, pageNo]);

  useEffect(() => {
    async function fetchMyAPI() {
      // Reset on first load
      dispatch(resetData());

      dispatch(
        fetchStatusParam({
          paramGroupId: "STATUS",
          pageNo: 1,
          pageSize: 20,
        })
      );

      dispatch(
        fetchReasonParam({
          paramGroupId: "REASON",
          pageNo: 1,
          pageSize: 20,
        })
      );
      dispatch(
        fetchClient({
          pageNo: 1,
          pageSize: 1000,
        })
      );
    }

    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (id != null) {
      callApiId(id);
    }
  }, [id]);

  useEffect(() => {
    setPlantCode(defaultPlant);
    setClientCode(defaultClient);
  }, []);
  const callApiId = async (id) => {
    console.log(overlay, "1");

    setOverlay(true);
    console.log(overlay, "2");

    try {
      const response = await dispatch(
        fetchAll({
          startDate: "",
          endDate: "",
          retNumber: id,
          invoiceNo: "",
          customerName: "",
          customerCode: "",
          plantCode: "",
          reasonCode: "",
          status: "",
          pageNo: 1,
          pageSize: 25,
          materialName: "",
          materialCode: "",
          clientCode: "",
          step: "",
        })
      );

      console.log(overlay, "overlay");
      if (response.payload.status === 200) {
        setOverlay(false);
      } else {
        setOverlay(false);
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      setOverlay(false);

      // showErrorDialog("Something went wrong!");
    }
  };

  const reasonOptions = [
    { value: "", label: "All" },
    ...reasonParam.map((e) => {
      const item = {};
      item.value = e.paramCode;
      item.label = e.paramValue;
      return item;
    }),
  ];

  const statusOptions = [
    { value: "", label: "All" },
    ...statusParam.map((e) => {
      const item = {};
      item.value = e.paramCode;
      item.label = e.paramValue;
      return item;
    }),
  ];

  const handleSearch = () => {
    if (plantCode.length < 1) {
      return showErrorDialog("Please select plant");
    }

    if (defaultClient.length > 1 && clientCode < 1) {
      return showErrorDialog("Please select Client ");
    }
    const params = {
      startDate: formatDatePost(startDate),
      endDate: formatDatePost(endDate),
      retNumber: retNumber.replace(/\s/g, ""),
      invoiceNo: invoiceNo,
      customerName: customerName,
      customerCode: customerCode,
      plantCode: plantCode.toString(),
      reasonCode: reason,
      status: status,
      pageNo: 1,
      pageSize: 10,
      materialName: materialName,
      materialCode: materialCode,
      clientCode: clientCode.toString(),
      // step: "",
    };
    dispatch(fetchAll(params));
  };

  const handleTableChange = async (
    type,
    { page, sizePerPage, sortField, sortOrder, data }
  ) => {
    if (type === "pagination") {
      if (plantCode.length < 1) {
        return showErrorDialog("Please select plant");
      }

      if (defaultClient.length > 1 && clientCode < 1) {
        return showErrorDialog("Please select Client ");
      }
      const params = {
        startDate: formatDatePost(startDate),
        endDate: formatDatePost(endDate),
        retNumber: retNumber.replace(/\s/g, ""),
        invoiceNo: invoiceNo,
        customerName: customerName,
        customerCode: customerCode,
        reasonCode: reason,
        clientCode: clientCode.toString(),
        status: status,
        // stepCode: '',
        plantCode: plantCode.toString(),
        pageNo: page,
        pageSize: sizePerPage,
      };
      dispatch(fetchAll(params));
    } else {
      let result;
      if (sortOrder === "asc") {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return 1;
          } else if (b[sortField] > a[sortField]) {
            return -1;
          }
          return 0;
        });
        console.log(result, "asc");
      } else {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return -1;
          } else if (b[sortField] > a[sortField]) {
            return 1;
          }
          return 0;
        });
        console.log(result, "desc");
      }
    }
  };

  const handleExcel = () => {
    // Validation
    if (startDate === "" || startDate === null) {
      return showErrorDialog("Please Input Registration Date!");
    }

    if (endDate === "" || endDate === null) {
      return showErrorDialog("Please Input Registration Date!");
    }

    const extendedData = clientCode.flatMap((item) => [item, "0000" + item]);


    let URL_EXCEL =
      `${process.env.REACT_APP_API_URL}/return/detailxlsx` +
      `?startDate=${formatDatePost(startDate)}` +
      `&endDate=${formatDatePost(endDate)}` +
      `&retNumber=${retNumber}` +
      `&invoiceNo=${invoiceNo}` +
      `&customerName=${customerName}` +
      `&customerCode=${customerCode}` +
      // `&plantCode=${plantName}` +
      `&plantCode=${plantCode.toString()}` +
      `&reasonCode=${reason}` +
      `&status=${status}` +
      `&clientCode=${extendedData.toString()}`;

    window.open(URL_EXCEL);
  };

  const getValueReason = (value, options) => {
    const return_value = options.filter((val) => value === val.value);
    return return_value;
  };

  const getValueStatus = (value, options) => {
    const return_value = options.filter((val) => value === val.value);
    return return_value;
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  const handlePlantsChange = (selectedOptions) => {
    if (selectedOptions) {
      setPlantCode(
        selectedOptions.map(function(selectedOptions) {
          if (selectedOptions) {
            return selectedOptions["value"];
          }
        })
      );
    } else {
      setPlantCode([]);
    }
  };

  const plantOptions = user.plants.map((val) => {
    return {
      value: val.plantCode,
      label: val.plantName,
    };
  });

  function getValuePlant(plant) {
    let output = [];
    plant.map((val) => {
      const result = plantOptions.filter((plant) => val == plant.value);
      output.push(result[0]);
    });
    return output;
  }

  const handleClientChange = (selectedOptions) => {
    if (selectedOptions) {
      setClientCode(
        selectedOptions.map(function(selectedOptions) {
          if (selectedOptions) {
            return selectedOptions["value"];
          }
        })
      );
    } else {
      setClientCode([]);
    }
  };

  const clientOptions =
    user.clients.length > 0
      ? user.clients.map((val) => {
          return {
            value: val.clientCode,
            label: val.clientName,
          };
        })
      : dataClient.map((val) => {
          return {
            value: val.clientCode,
            label: val.clientName,
          };
        });

  function getValueClient(client) {
    let output = [];
    client.map((val) => {
      const result = clientOptions.filter((client) => val == client.value);
      output.push(result[0]);
    });
    return output;
  }

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <Card>
      <LoadingFetchData active={overlay} />
      <CardHeader title="Report Details">
        <CardHeaderToolbar>
          <Button variant="primary" onClick={handleExcel}>
            Download Excel
          </Button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        {/* Filter */}
        <Form as={Row}>
          {/* Left Row */}
          <Col sm={7}>
            <Form.Group as={Row}>
              <Form.Label column sm={3}>
                <b>Registration Date</b>
              </Form.Label>
              <Col sm={4}>
                <DatePicker
                  className="form-control"
                  dateFormat="dd/MM/yyyy"
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                  isClearable
                  placeholderText="dd/mm/yyyy"
                />
              </Col>
              <p className="mt-3">To</p>
              <Col sm={4}>
                <DatePicker
                  className="form-control"
                  dateFormat="dd/MM/yyyy"
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
                  isClearable
                  placeholderText="dd/mm/yyyy"
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="retNumber">
              <Form.Label column sm={3}>
                <b>APL Return Number </b>
              </Form.Label>
              <Col sm={4}>
                <Form.Control
                  type="text"
                  placeholder="APL Return Number "
                  onChange={(e) => {
                    setRetNumber(e.target.value);
                  }}
                  value={retNumber}
                  onKeyPress={handleKeyPress}
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row}>
              <Form.Label column sm={3}>
                <b>Invoice Ref Number</b>
              </Form.Label>
              <Col sm={4}>
                <Form.Control
                  type="text"
                  placeholder="Invoice Ref Number"
                  onChange={(e) => {
                    setInvoiceNo(e.target.value);
                  }}
                  value={invoiceNo}
                  onKeyPress={handleKeyPress}
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row}>
              <Form.Label column sm={3}>
                <b>Customer Name</b>
              </Form.Label>
              <Col sm={4}>
                <Form.Control
                  type="text"
                  placeholder="Customer Name"
                  onChange={(e) => {
                    setCustomerName(e.target.value);
                  }}
                  value={customerName}
                  onKeyPress={handleKeyPress}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row}>
              <Form.Label column sm={3}>
                <b>Plants</b>
              </Form.Label>
              <Col sm={4}>
                <MultiSelectAll
                  options={plantOptions}
                  value={getValuePlant(plantCode)}
                  onChange={handlePlantsChange}
                  placeholder="Select Plant..."
                />
              </Col>
            </Form.Group>
            {checkRoles(role, clientAllowed) && (
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Clients</b>
                </Form.Label>
                <Col sm={4}>
                  <MultiSelectAll
                    options={clientOptions}
                    value={getValueClient(clientCode)}
                    onChange={handleClientChange}
                    placeholder="Select Client..."
                  />
                </Col>
              </Form.Group>
            )}
          </Col>

          {/* Right Row */}
          <Col sm={5}>
            {/* <Form.Group as={Row}>
              <Form.Label column sm={3}>
                <b>Plant</b>
              </Form.Label>
              <Col sm={6}>
                <Form.Control
                  as="textarea"
                  disabled
                  // onChange={(e) => {
                  //   setPlantName(e.target.value);
                  // }}
                  value={plantsNameUser}
                  // onKeyPress={handleKeyPress}
                />
              </Col>
            </Form.Group> */}

            <Form.Group as={Row}>
              <Form.Label column sm={3}>
                <b>Reason</b>
              </Form.Label>
              <Col sm={6}>
                <Select
                  options={reasonOptions}
                  value={getValueReason(reason, reasonOptions)}
                  placeholder="Select Reason..."
                  onChange={(e) => {
                    setReason(e.value);
                  }}
                  onKeyPress={handleKeyPress}
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row}>
              <Form.Label column sm={3}>
                <b> Status</b>
              </Form.Label>
              <Col sm={6}>
                <Select
                  options={statusOptions}
                  value={getValueStatus(status, statusOptions)}
                  placeholder="Select Status..."
                  onChange={(e) => {
                    setStatus(e.value);
                  }}
                  onKeyPress={handleKeyPress}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row}>
              <Form.Label column sm={3}>
                <b>Material Name</b>
              </Form.Label>
              <Col sm={6}>
                <Form.Control
                  type="text"
                  placeholder="Material Name"
                  onChange={(e) => {
                    setMaterialName(e.target.value);
                  }}
                  value={materialName}
                  onKeyPress={handleKeyPress}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row}>
              <Form.Label column sm={3}>
                <b>Customer Code</b>
              </Form.Label>
              <Col sm={6}>
                <Form.Control
                  type="text"
                  placeholder="Customer Code"
                  onChange={(e) => {
                    setCustomerCode(e.target.value);
                  }}
                  value={customerCode}
                  onKeyPress={handleKeyPress}
                />
              </Col>
            </Form.Group>
          </Col>

          {/* Button */}
          <Form.Group as={Row} className="ml-1">
            <Col sm={6}>
              <Button className="btn btn-primary" onClick={handleSearch}>
                Search
              </Button>
            </Col>
          </Form.Group>
        </Form>

        {/* Table */}

        {data.length > 0 && (
          <div className="table-container">
            <ReportDetailTable
              data={tableData}
              page={pageNo}
              sizePerPage={pageSize}
              totalSize={totalRecord}
              onTableChange={handleTableChange}
              loading={loading}
            />
          </div>
        )}
      </CardBody>
    </Card>
  );
};
